<div id="certificateContainer" style="position: relative; text-align: center">
  <img
    id="certificateIframe"
    class="certificate-image"
    src="assets/Module-certificate.png"
    style="
      width: 100%;
      height: auto;
      border: none;
      display: block;
      margin: 0 auto;
    "
  />

  <div
    class="responseText"
    style="
      position: absolute;
      top: 42%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: rgb(42, 39, 39);
      font-size: 15px;
      text-align: center;
      white-space: normal;
      max-width: 80%;
      word-break: break-word;
    "
  >
    This certificate is awarded to
    <span style="margin-left: 2%; margin-right: 2%; font-weight: bold">
      {{ name }}
    </span>
    for successful completion.
  </div>
  <div
  class="responseText module-name"
  style="
    position: absolute;
    bottom: 45.6%;
    left: 50%;
    transform: translateX(-50%);
    color: rgb(255, 255, 255);
    font-size: 15px;
    text-align: center;
    font-style: italic;
    font-weight: bold;
  "
>
{{moduleTitle}}
</div>
<div>
  <div
    class="responseText date-res"
    style="
      position: absolute;
      bottom: 36.5%;
      left: 38%; /* Adjusted to move left */
      transform: translateX(-50%);
      color: rgb(42, 39, 39);
      font-size: 12px;
      text-align: center;
    "
  >
    <span style="font-weight: bold;">Completion Date :</span> {{certificateDate}}
  </div>
</div>

</div>

<button
  id="downloadBtn"
  class="floating-button"
  (click)="downloadCertificate(moduleId, certificateId)"
>
  Download
</button>
<!-- 
<div id="certificateContainer" style="position: relative; text-align: center">
  <img
    id="certificateIframe"
    class="certificate-image"
    src="assets/module-completion.png"
    style="
      width: 100%;
      height: auto;
      border: none;
      display: block;
      margin: 0 auto;
    "
  />

  <div
    class="responseText"
    style="
      position: absolute;
      top: 42%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: rgb(42, 39, 39);
      font-size: 17px;
      text-align: center;
      white-space: normal;
      max-width: 80%;
      word-break: break-word;
    "
  >
    This certificate is awarded to
    <span style="margin-left: 2%; margin-right: 2%; font-weight: bold">
      {{ name }}
    </span>
    for successful completion.
  </div>

  <div
    class="responseText date-res"
    style="
      position: absolute;
      bottom: 36.5%;
      left: 40%;
      transform: translateX(-50%);
      color: rgb(42, 39, 39);
      font-size: 12px;
      text-align: center;
    "
  >
    30:10:2000
  </div>
</div>

<button
  id="downloadBtn"
  class="floating-button"
  (click)="downloadCertificate()"
>
  Download
</button> -->
